import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';

const faqs = [
  {
    question: "Qu'est-ce que RepriScan ?",
    answer: "RepriScan est un outil de prédiagnostic pour les repreneurs d'entreprise. Il vous permet d'analyser rapidement un dossier de reprise (documents financiers, activité, risques) et d'obtenir un verdict clair : poursuivre, approfondir ou passer. C'est un filtre intelligent pour ne pas perdre de temps sur des projets inadaptés.",
  },
  {
    question: "Est-ce que ça remplace un expert-comptable ?",
    answer: "Non, RepriScan est un outil de premier filtre. Il vous aide à identifier rapidement les dossiers qui méritent votre attention avant d'engager des frais d'expert. Pour une due diligence complète, vous aurez toujours besoin d'un expert-comptable ou d'un conseil M&A.",
  },
  {
    question: "Mes données sont-elles sécurisées ?",
    answer: "Oui, absolument. Vos documents et analyses sont strictement privés et sécurisés. Nous utilisons un hébergement sécurisé et aucune donnée n'est partagée avec des tiers. Vous pouvez supprimer vos dossiers à tout moment.",
  },
  {
    question: "Que faire après mon verdict ?",
    answer: "RepriScan vous fournit des recommandations actionnables : questions à poser au cédant, points à clarifier avec votre banquier, et éléments à approfondir. Vous pouvez exporter un PDF professionnel à partager avec vos conseillers.",
  },
];

export function FAQSection() {
  return (
    <section className="py-16 md:py-24 bg-muted/30">
      <div className="max-w-3xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold mb-4">
            Questions fréquentes
          </h2>
        </div>
        
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, index) => (
            <AccordionItem key={index} value={`item-${index}`}>
              <AccordionTrigger className="text-left font-medium">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
